import { isEmpty } from 'lodash';
import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import QCXNovoDocumentoClientFormDialog from './QCXNovoDocumentoClientFormDialog';
import { CLOSED_STATUS, OPEN_STATUS } from '../../utils/hooks/form/dialog/formDialogUtils';

export default function QCXDocumentoClientViewerModal({ documento, open, onClose, parentModel, onSuccess }) {
    const { t } = useTranslation();

    const initialDocumentModel = useMemo(() => {
        if (!documento || isEmpty(documento)) return null;

        return {
            id: documento.id, 
            tipoDocumento: documento.tipoDocumento, 
            tipo: documento.tipo,
            nome: documento.nome,
            arquivo: documento.arquivo,
            numero: documento.numero,
            vencimento: documento.dataVencimento,
            notificar: documento.notificar,
        };
    }, [documento]);

    const handleFormDialogStatus = useCallback((newStatus) => {
        if (newStatus === CLOSED_STATUS || newStatus === 'done' || newStatus === 'fail') {
            onClose(); 
        }
    }, [onClose]);

    if (!open || !documento || isEmpty(documento)) return null;

    return (
        <QCXNovoDocumentoClientFormDialog
            parentModel={parentModel}
            initialModel={initialDocumentModel}
            status={open ? OPEN_STATUS : CLOSED_STATUS}
            handleStatus={handleFormDialogStatus}
            onSuccess={() => {
                if (typeof onSuccess === 'function') {
                   onSuccess();
                }
                handleFormDialogStatus(CLOSED_STATUS);
            }}
        />
    )
}